module.exports = __webpack_public_path__ + "static/tomato-screen1-6ea47fc8b81316ae501d9b8b0a7d1bc8.jpg";